import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './campeonato.css';
import React from 'react';
import routes from "./routes";
import {useRoutes} from "react-router-dom";

const App = () => {
  const routing = useRoutes(routes);

  return (
    <>
      {routing}
    </>
  );
};

export default App;
